import { forgotPassword } from 'util/api'
import { useDocTitle } from 'util/hooks'

import React, { useState } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import 'css/pages/forgot-password.css'
import { showToast } from 'components/toast'

export const ForgotPassword = () => {
	const searchParams = new URLSearchParams(window.location.search)
	const from = searchParams.get('from')
	const navigate = useNavigate()

	const [ email, setEmail ] = useState()

	const onFormSubmit = async event => {
		event.preventDefault()
		const response = await forgotPassword(email)

		if (response.status === 200) {
			navigate(
				`/reset-password?email=${email}`
				+ (from ? `&from=${from}` : '')
			)
			return
		}

		showToast("Something went wrong. Please try again.")
	}

	useDocTitle('All for One - Forgot Password')

	return (
		<section className="forgot-password-container">
			<h1 className="forgot-password-header">
				{from === 'settings'
					? 'Update password'
					: 'Forgot password'
				}
			</h1>

			{from !== 'settings' && (<p className="forgot-password-note">
					Note: If you are a student, ask your teacher for help logging in first.
				</p>)
			}

			<p className="forgot-password-instruction">
				Enter your email so we can verify it’s you.
			</p>

			<form
				id="forgot-password-form"
				action="#"
				method="POST"
				onSubmit={onFormSubmit}
			>
				<div className="form-group">
					<label htmlFor="email" className="visually-hidden"></label>
					<input 
						type="email" 
						id="email" 
						name="email" 
						placeholder="Email" 
						required
						onBlur={({ target }) => setEmail(target.value)}
					/>
				</div>

				<div className="form-group">
					<button type="submit" className="forgot-password-btn">Send Code</button>
				</div>
			</form>

			<p className="login-prompt">
				<span>{from === 'settings'
					? 'Changed your mind?'
					: 'Remembered your password?'
				}</span>
				<Link
					to={from === 'settings' ? '/settings' : '/login'}
					className="login-link"
				>{from === 'settings'
					? 'Back to settings!'
					: 'Log in!'
				}</Link>
			</p>
		</section>
	)
}
